/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewResolvedFinding } from './CRSFSecReviewResolvedFinding';
import {
    CRSFSecReviewResolvedFindingFromJSON,
    CRSFSecReviewResolvedFindingFromJSONTyped,
    CRSFSecReviewResolvedFindingToJSON,
} from './CRSFSecReviewResolvedFinding';

/**
 * 
 * @export
 * @interface CRSFSecReviewResolvedFindingsPagedResponse
 */
export interface CRSFSecReviewResolvedFindingsPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewResolvedFindingsPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewResolvedFindingsPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFSecReviewResolvedFinding>}
     * @memberof CRSFSecReviewResolvedFindingsPagedResponse
     */
    results?: Array<CRSFSecReviewResolvedFinding>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewResolvedFindingsPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFSecReviewResolvedFindingsPagedResponse interface.
 */
export function instanceOfCRSFSecReviewResolvedFindingsPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFSecReviewResolvedFindingsPagedResponseFromJSON(json: any): CRSFSecReviewResolvedFindingsPagedResponse {
    return CRSFSecReviewResolvedFindingsPagedResponseFromJSONTyped(json, false);
}

export function CRSFSecReviewResolvedFindingsPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewResolvedFindingsPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFSecReviewResolvedFindingFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFSecReviewResolvedFindingsPagedResponseToJSON(value?: CRSFSecReviewResolvedFindingsPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFSecReviewResolvedFindingToJSON)),
        'total': value.total,
    };
}

